import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/WEB-frontend/app/aos.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/WEB-frontend/components/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/WEB-frontend/components/landing/landing-lead-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/WEB-frontend/components/newsletter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/WEB-frontend/components/ui/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/WEB-frontend/components/whatsapp-lead-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/WEB-frontend/components/whatsapp/whatsapp-chat-link.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/WEB-frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/WEB-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/WEB-frontend/public/images/LOGO-ABOGACIA.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/WEB-frontend/public/images/LOGO-ICAM.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/WEB-frontend/public/images/nomad.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/WEB-frontend/public/images/permiso-residencia.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/WEB-frontend/public/images/student.jpg");
